import type { ScreenSchema } from './types';

const likertQuestionSchema: ScreenSchema = {
  template: 'likert-question',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    },
    // Likert has a single feedback text (no correct/incorrect variants)
    feedback: { parts: [{ field: 'feedback' }] }
  }
};

export default likertQuestionSchema;
